import Home from './components/Home.vue';
import Library from './components/Library.vue';
import Error from './components/404.vue';

import Book from './components/Book.vue';
import Author from './components/Author.vue';
import AddNewBook from './components/AddNewBook.vue';
import Search from './components/Search.vue';

import Profile from './components/Profile.vue';
import ProfileLibrary from './components/Profile/Library.vue';
import LikedBooks from './components/Profile/LikedBooks.vue';
import ReadBooks from './components/Profile/ReadBooks.vue';
import ToReadList from './components/Profile/ToReadList.vue';
import Friends from './components/Profile/Friends.vue';

import ForgotPassword from './components/SignIn/ForgotPassword.vue';
import ResetPassword from './components/SignIn/ResetPassword.vue';
import Login from './components/SignIn/Login.vue';

const routes = [
	{ path: '/', component: Home },
	{ path: '/library', component: Library },

	{ path: '/book/:id', component: Book },
	{ path: '/author/:id', component: Author },
	{ path: '/add-new-book', component: AddNewBook },
	{ path: '/search/:keywords', component: Search },

	{ path: '/profile/:id', component: Profile },
	{ path: '/profile/:id/library', component: ProfileLibrary },
	{ path: '/profile/:id/liked', component: LikedBooks },
	{ path: '/profile/:id/read', component: ReadBooks },
	{ path: '/profile/:id/to-read', component: ToReadList },
	{ path: '/profile/:id/friends', component: Friends },

	{ path: '/forgot-password', component: ForgotPassword },
	{ path: '/forgot-password/:id', component: ResetPassword },
	{ path: '/login', component: Login },

	{ path: "*", component: Error, name: '404' },
];

export default routes;